export enum IAccountTwoFactorMethod {
    EMAIL = 1,
    TOTP = 2
}